import { z } from 'zod';
import type { PartialUndefinedOrNull } from '@/types/partial';
import { type RegraFiscalCofinsBody, RegraFiscalCofinsSchema } from './RegraFiscalCofins';
import { type RegraFiscalIbsCbsBody, RegraFiscalIbsCbsSchema } from './RegraFiscalIbsCbs';
import { type RegraFiscalIcmsBody, RegraFiscalIcmsSchema } from './RegraFiscalIcms';
import {
    type RegraFiscalInformacoesBody,
    RegraFiscalInformacoesSchema,
} from './RegraFiscalInformacoes';
import { type RegraFiscalIpiBody, RegraFiscalIpiSchema } from './RegraFiscalIpi';
import { type RegraFiscalIsBody, RegraFiscalIsSchema } from './RegraFiscalIs';
import { type RegraFiscalPisBody, RegraFiscalPisSchema } from './RegraFiscalPis';
import { RegraFiscalServicoSchema, type RegraFiscalServicoBody } from './RegraFiscalServico';

export enum RegraFiscalTipo {
    Produto = 1,
    Servico = 2,
}

export const RegraFiscalSchema = z.object({
    ref_descricao: z.string().nullable(),
    ref_empresa_idpk: z.number(),
    ref_idpk: z.number(),
    ref_nfe_altera_regra: z.enum(['S', 'N']).nullable(),
    ref_tipo: z.enum(RegraFiscalTipo),
    ref_ultima_alteracao: z.string().nullable(),
    regra_fiscal_cofins: RegraFiscalCofinsSchema.array().nullable(),
    regra_fiscal_ibscbs: RegraFiscalIbsCbsSchema.array().nullable(),
    regra_fiscal_icms: RegraFiscalIcmsSchema.array().nullable(),
    regra_fiscal_informacoes: RegraFiscalInformacoesSchema.array().nullable(),
    regra_fiscal_ipi: RegraFiscalIpiSchema.array().nullable(),
    regra_fiscal_is: RegraFiscalIsSchema.array().nullable(),
    regra_fiscal_pis: RegraFiscalPisSchema.array().nullable(),
    regra_fiscal_servico: RegraFiscalServicoSchema.array().nullable(),
});

export type RegraFiscal = z.infer<typeof RegraFiscalSchema>;

export type RegraFiscalBody = PartialUndefinedOrNull<
    Omit<
        RegraFiscal,
        | 'regra_fiscal_cofins'
        | 'regra_fiscal_ibscbs'
        | 'regra_fiscal_icms'
        | 'regra_fiscal_informacoes'
        | 'regra_fiscal_ipi'
        | 'regra_fiscal_is'
        | 'regra_fiscal_pis'
        | 'regra_fiscal_servico'
    >
> & {
    regra_fiscal_cofins?: RegraFiscalCofinsBody[] | null;
    regra_fiscal_ibscbs?: RegraFiscalIbsCbsBody[] | null;
    regra_fiscal_icms?: RegraFiscalIcmsBody[] | null;
    regra_fiscal_informacoes?: RegraFiscalInformacoesBody[] | null;
    regra_fiscal_ipi?: RegraFiscalIpiBody[] | null;
    regra_fiscal_is?: RegraFiscalIsBody[] | null;
    regra_fiscal_pis?: RegraFiscalPisBody[] | null;
    regra_fiscal_servico?: RegraFiscalServicoBody[] | null;
};
